<template>
  <b-modal
    id="recap-add-annonce"
    class="recap-full-screen-modal"
    header-class="recap-header"
    ref="modal"
    centered
    hide-footer
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-perso-ok.png`)" class="recap-img" >
        <div class="recap-container h-100">
          <h1 class="page-title mt-4 ml-4 subtitle-recap-add">{{$t('annonce.new')}}</h1>
        </div>
      </div>
    </template>

    <div>
      <div class="row justify-content-between mt-2 mb-3">
        <div class="col-6">
          <b-button variant="outline-primary" @click="addNewAnnonce('fast')" class="h-100 w-100 flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <span class="align-self-center mt-small-px">{{$t('annonce.create.Fast')}}</span>
            </div>
          </b-button>
        </div>
        <div class="col-6">
          <b-button variant="primary" @click="addNewAnnonce('complete')" class="h-100 w-100 d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <span class="align-self-center mt-small-px">{{$t('annonce.create.Full')}}</span>
            </div>
          </b-button>
        </div>
      </div>
      <div class="row" v-if="nbDrafts > 0">
        <div class="col-12 d-flex">
          <b-button @click="openBrouillonModal" class="w-100" variant="secondary">
            <div class="d-flex justify-content-center">
              <span class="align-self-center mt-small-px">{{$t('annonce.my.draft')}}</span>
            </div>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {

  name:"RecapAddAnnonce",

  data() {
    return {
      nbDrafts: null
    }
  },

  mounted() {
    this.fetchNbDrafts()
  },

  emits:['openBrouillonModal'],

  methods: {

    fetchNbDrafts() {
      api({
        method: "GET",
        url: '/annonce/getMyDraftAnnonceReadyToPublish',
      })
        .then(async (response) => {
          this.nbDrafts = response.data.length
        })
    },

    openBrouillonModal() {
      this.$emit('openBrouillonModal')
    },

    addNewAnnonce(creationType){
      this.$emit('addNewAnnonce',creationType)
    },
  },
};
</script>

<!-- not scoped car modal --><style>

#recap-add-annonce .modal-content,
#recap-add-annonce .modal-header,
#recap-add-annonce .modal-body,
#recap-add-annonce .modal-footer{
  background-color: var(--main-black-dark);
}

#recap-add-annonce .recap-title{
  font-size: 34px!important;
}

#recap-add-annonce .subtitle-recap-add{
  font-size: 24px;
}

#recap-add-annonce .recap-img{
  max-width: 200px;
}
#recap-add-annonce .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

#recap-add-annonce .recap-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#recap-add-annonce .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

#recap-add-annonce .recap-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}
/* pour affichage mobile (under md) : scroll pas sur le header de la modale */
@media (max-width: 768px) {
  #recap-add-annonce .recap-header {
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }
}
#recap-add-annonce .recap-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  #recap-add-annonce .recap-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  #recap-add-annonce .recap-container img {
    order: 2;
    align-self: center;
  }
  #recap-add-annonce .recap-container {
    text-align: center;
  }
}

#recap-add-annonce .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

#recap-add-annonce .recap-header {
  padding-bottom: 0!important;
}

#recap-add-annonce.recap-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
#recap-add-annonce.recap-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #recap-add-annonce .modal-content {
    display: flex;
    overflow: auto;
    margin: 0.5em;
  }
  #recap-add-annonce .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #recap-add-annonce .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #recap-add-annonce .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #recap-add-annonce .modal-content {
    padding: 0;
  }
  .modal-header-content , .recap-container {
    padding: 10px;
  }
  #recap-add-annonce .recap-img {
    max-width: 125px;
  }
}

@media (max-height: 852px) {
  #recap-add-annonce .modal-content {
    overflow: auto;
  }
  #recap-add-annonce .recap-title{
    font-size: 24px!important;
  }

  #recap-add-annonce .subtitle-recap-add{
    font-size: 18px;
  }
  #recap-add-annonce .modal-header-content , .recap-container {
    padding: 2px;

  }
}





</style>



// WEBPACK FOOTER //
// src/components/annonce/RecapAddAnnonce.vue